export const grilleTarifaireBasePath = 'grille-tarifaire';
export const grilleTarifairePath = '';
export const grilleTarifaireFullPath = `${grilleTarifaireBasePath}/${grilleTarifairePath}`;
